module.exports = __webpack_public_path__ + "static/media/host-landing-bg.f5f0b78b.svg";